import { createorderQuery } from "../../graphql/queries";
import type { CreateOrderInput, CreateOrderMutation, CreateOrderMutationVariables, RefreshTokenMutationVariables } from "../../graphql/types";
import { fetchGraphql } from "./graphqlClient";

export async function createOrder(input: CreateOrderInput) {
    return await fetchGraphql<CreateOrderMutation, CreateOrderMutationVariables>("CreateOrder", createorderQuery, { input }, false);
}
